import * as React from 'react'

import { useTranslation } from 'react-i18next'
import EvenementProComponent from '../../components/Evenements/Evenement_pro.component'

import NavbarComponent from '../../components/Navbar/Navbar.component'
import FooterComponent from '../../components/Footer/Footer.component'

import HeaderComponent from '../../components/Header/Header.component'

function EvenementsPro() {
  const { t } = useTranslation()
  return (
    <div>
      <NavbarComponent />
      <div>
        <HeaderComponent title={t('event_pro_title')} />
      </div>
      <EvenementProComponent />
      <FooterComponent />
    </div>
  )
}

export default EvenementsPro
